/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zoom_ControlsInputs */

const en_zoom_controls = /** @type {(inputs: Zoom_ControlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom controls`)
};

const fr_zoom_controls = /** @type {(inputs: Zoom_ControlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commandes de zoom`)
};

const de_zoom_controls = /** @type {(inputs: Zoom_ControlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom-Steuerung`)
};

const it_zoom_controls = /** @type {(inputs: Zoom_ControlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controlli dello zoom`)
};

const ru_zoom_controls = /** @type {(inputs: Zoom_ControlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Элементы управления масштабированием`)
};

const es_zoom_controls = /** @type {(inputs: Zoom_ControlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controles de zoom`)
};

const zh_cn2_zoom_controls = /** @type {(inputs: Zoom_ControlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`缩放控制`)
};

const ja_zoom_controls = /** @type {(inputs: Zoom_ControlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ズームコントロール`)
};

const hi_zoom_controls = /** @type {(inputs: Zoom_ControlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ज़ूम नियंत्रण`)
};

const pt_pt2_zoom_controls = /** @type {(inputs: Zoom_ControlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`controles de zoom`)
};

/**
* | output |
* | --- |
* | "Zoom controls" |
*
* @param {Zoom_ControlsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const zoom_controls = /** @type {((inputs?: Zoom_ControlsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zoom_ControlsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_zoom_controls(inputs)
	if (locale === "de") return de_zoom_controls(inputs)
	if (locale === "it") return it_zoom_controls(inputs)
	if (locale === "ru") return ru_zoom_controls(inputs)
	if (locale === "es") return es_zoom_controls(inputs)
	if (locale === "zh-CN") return zh_cn2_zoom_controls(inputs)
	if (locale === "ja") return ja_zoom_controls(inputs)
	if (locale === "hi") return hi_zoom_controls(inputs)
	if (locale === "pt-PT") return pt_pt2_zoom_controls(inputs)
	return en_zoom_controls(inputs)
});